<template>
  <div class="main-content-container">
    <b-modal
      @close="closeModal()"
      id="mFormMerchantSubAccountMarketPlace"
      title="Subconta Marketplace "
      size="lg"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <div v-if="existValue">
        <b-nav tabs fill>
          <b-nav-item class="py-0" :class="selectedNav == 0 ? 'active-item' : ''" @click="selectedNav = 0">
            <i class="fas fa-barcode"></i> Boleto
          </b-nav-item>
          <b-nav-item :class="selectedNav == 1 ? 'active-item' : ''" @click="selectedNav = 1">
            <i class="far fa-credit-card"></i> Cartão de Crédito</b-nav-item
          >
          <!-- <b-nav-item :class="selectedNav == 2 ? 'active-item' : ''" @click="selectedNav = 2">
            <i class="fab fa-bitcoin"></i> Criptomoeda</b-nav-item
          >
          <b-nav-item :class="selectedNav == 3 ? 'active-item' : ''" @click="selectedNav = 3">
            <i class="far fa-credit-card"></i> Cartão de Débito</b-nav-item
          > -->
          <b-nav-item :class="selectedNav == 4 ? 'active-item' : ''" @click="selectedNav = 4">
            <i class="fas fa-hand-holding-usd"></i> PIX
          </b-nav-item>
        </b-nav>

        <div class="col-md-12" v-if="selectedNav == 0">
          <div form-group col-md-2 style="text-align: center">
            <b-form-checkbox
              disabled
              size="lg"
              style="display: inline-block; margin: 10px;padding-left: 0.8125rem;"
              v-model="Company.PaymentMethods.BankSlip"
              switch
            >
              {{ Company.PaymentMethods.BankSlip ? "Habilitado" : "Desabilitado" }}
            </b-form-checkbox>
          </div>

          <div v-if="Company.PaymentMethods.BankSlip == true" class="form-group form-material row">
            <label class="col-md-4 col-form-label">Repasse de taxa de custo: </label>
            <div class="col-md-6">
              <input type="text" disabled class="form-control " v-model="DataBankslip.transfer" />
            </div>
            <hr />
            <template v-if="DataBankslip && DataBankslip.Taxes.length > 0">
              <div v-for="(tax, index) in DataBankslip.Taxes" :key="index">
                <label class="col-md-4 col-form-label">Tipo de taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxType" />
                </div>
                <hr />
                <label class="col-md-4 col-form-label">Valor da taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxValue" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="col-md-12" v-if="selectedNav == 1">
          <div form-group col-md-2 style="text-align: center">
            <b-form-checkbox
              disabled
              size="lg"
              style="display: inline-block; margin: 10px;padding-left: 0.8125rem;"
              v-model="Company.PaymentMethods.CreditCard"
              switch
            >
              {{ Company.PaymentMethods.CreditCard ? "Habilitado" : "Desabilitado" }}
            </b-form-checkbox>
          </div>
          <div v-if="Company.PaymentMethods.CreditCard == true" class="form-group form-material row">
            <label class="col-md-4 col-form-label">Repasse de taxa de custo: </label>

            <div class="col-md-6">
              <input type="text" disabled class="form-control " v-model="DataCreditCard.transfer" />
            </div>
            <hr />
            <template v-if="DataCreditCard && DataCreditCard.Taxes.length > 0">
              <div v-for="(tax, index) in DataCreditCard.Taxes" :key="index">
                <label class="col-md-4 col-form-label">Tipo de taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxType" />
                </div>
                <hr />
                <label class="col-md-4 col-form-label">Valor da taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxValue" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="col-md-12" v-if="selectedNav == 2">
          <div form-group col-md-2 style="text-align: center">
            <b-form-checkbox
              disabled
              size="lg"
              style="display: inline-block; margin: 10px;padding-left: 0.8125rem;"
              v-model="Company.PaymentMethods.Bitcoin"
              switch
            >
              {{ Company.PaymentMethods.Bitcoin ? "Habilitado" : "Desabilitado" }}
            </b-form-checkbox>
          </div>
          <div v-if="Company.PaymentMethods.Bitcoin == true" class="form-group form-material row">
            <label class="col-md-4 col-form-label">Repasse de taxa de custo: </label>
            <div class="col-md-6">
              <input type="text" disabled class="form-control" v-model="DataBitcoin.transfer" />
            </div>
            <hr />
            <template v-if="DataBitcoin && DataBitcoin.Taxes.length > 0">
              <div v-for="(tax, index) in DataBitcoin.Taxes" :key="index">
                <label class="col-md-4 col-form-label">Tipo de taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxType" />
                </div>
                <hr />
                <label class="col-md-4 col-form-label">Valor da taxa: </label>
                <div class="col-md-6">
                  <currency-input type="text" disabled class="form-control " v-model="tax.taxValue" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="col-md-12" v-if="selectedNav == 3">
          <div form-group col-md-2 style="text-align: center">
            <b-form-checkbox
              disabled
              size="lg"
              style="display: inline-block; margin: 10px;padding-left: 0.8125rem;"
              v-model="Company.PaymentMethods.DebitCard"
              switch
            >
              {{ Company.PaymentMethods.DebitCard ? "Habilitado" : "Desabilitado" }}
            </b-form-checkbox>
          </div>
          <div v-if="Company.PaymentMethods.DebitCard == true" class="form-group form-material row">
            <label class="col-md-4 col-form-label">Repasse de taxa de custo: </label>

            <div class="col-md-6">
              <input type="text" disabled class="form-control " v-model="DataDebitCard.transfer" />
            </div>
            <hr />
            <template v-if="DataDebitCard && DataDebitCard.Taxes.length > 0">
              <div v-for="(tax, index) in DataDebitCard.Taxes" :key="index">
                <label class="col-md-4 col-form-label">Tipo de taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxType" />
                </div>
                <hr />
                <label class="col-md-4 col-form-label">Valor da taxa: </label>
                <div class="col-md-6">
                  <currency-input type="text" disabled class="form-control " v-model="tax.taxValue" />
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="col-md-12" v-if="selectedNav == 4">
          <div form-group col-md-2 style="text-align: center">
            <b-form-checkbox
              disabled
              size="lg"
              style="display: inline-block; margin: 10px;padding-left: 0.8125rem;"
              v-model="Company.PaymentMethods.Pix"
              switch
            >
              {{ Company.PaymentMethods.Pix ? "Habilitado" : "Desabilitado" }}
            </b-form-checkbox>
          </div>
          <div v-if="Company.PaymentMethods.Pix == true" class="form-group form-material row">
            <label class="col-md-4 col-form-label">Repasse de taxa de custo: </label>

            <div class="col-md-6">
              <input type="text" disabled class="form-control " v-model="DataPix.transfer" />
            </div>
            <hr />
            <template v-if="DataPix && DataPix.Taxes.length > 0">
              <div v-for="(tax, index) in DataPix.Taxes" :key="index">
                <label class="col-md-4 col-form-label">Tipo de taxa: </label>
                <div class="col-md-6">
                  <input type="text" disabled class="form-control " v-model="tax.taxType" />
                </div>
                <hr />
                <label class="col-md-4 col-form-label">Valor da taxa: </label>
                <div class="col-md-6">
                  <currency-input type="text" disabled class="form-control " v-model="tax.taxValue" />
                </div>
              </div>
            </template>
          </div>
        </div>
        </div>
      </div>
      <template slot="modal-footer" >
        <b-button size="sm" @click="closeModal()">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "MerchantPaymenthMethod",
  data: function() {
    return {
      _showModal: false,
      selectedNav: 0,
      checked: false,
      loadingMerchantPaymenthMethod: false,
      Company: {},
      DataBankslip: null,
      DataCreditCard: null,
      DataBitcoin: null,
      DataDebitCard: null,
      DataPix: null,
      DataSms: null,
      DadosAdvance: null,
      DadosAntiFraud: null,
      loadingModal: false
    };
  },
  props: {
    idMerchant: {
      type: Number,
      required: true
    },
    idMerchantRoot: {
      type: Number,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    existValue() {
      return (
        this.DataBankslip != null ||
        this.DataCreditCard != null ||
        this.DataBitcoin != null ||
        this.DataDebitCard != null ||
        this.DataPix != null ||
        this.DataSms != null ||
        this.DadosAdvance != null ||
        this.DadosAntiFraud != null
      );
    }
  },
  watch: {
    showModal(newValue) {
      this._showModal = newValue;
      if (newValue == true) {
        this.$bvModal.show("mFormMerchantSubAccountMarketPlace");
        this.GetMerchantPaymenthMethod();
        this.selectedNav = 0;
      } else {
        this.$bvModal.hide("mFormMerchantSubAccountMarketPlace");
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:showModal", false);
    },

    CompanyPaymentDefault() {
      return {
        BankSlip: {},
        CreditCard: {},
        Bitcoin: {},
        DebitCard: {},
        Pix: {},
        AdvancePayment: {},
        SMS: {},
        AntiFraud: {}
      };
    },

    CompanyPaymentMethodsDefault() {
      return {
        BankSlip: false,
        CreditCard: false,
        Bitcoin: false,
        DebitCard: false,
        Pix: false,
        AdvancePayment: false,
        SMS: false,
        AntiFraud: false
      };
    },
    GetMerchantPaymenthMethod() {
      this.loadingModal = true;
      if (this.id != 0) {
        this.$store
          .dispatch("GetMerchantPaymenthMethod", { id: this.idMerchant, idMerchantRoot: this.idMerchantRoot })
          .then(response => {
            this.ProcessData(response);
            // setTimeout(() => {
            //   console.log(this.DataBitcoin, this.DataDebitCard, "get");
            // }, 3000);
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar os data", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },

    ListMerchantPaymenthMethod() {
      this.loadingMerchantPaymenthMethod = true;
      this.$store
        .dispatch("ListMerchantPaymenthMethod", { idMerchant: this.idMerchant })
        .then(response => {
          this.infoMerchantPaymenthMethod = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao obter os data do cliente", error);
        })
        .finally(() => {
          this.loadingMerchantPaymenthMethod = false;
        });
    },

    ProcessData(response) {
      this.Company = response;
      this.Company.Payment = this.CompanyPaymentDefault();
      this.Company.PaymentMethods = this.CompanyPaymentMethodsDefault();
      if (
        this.Company.Configuration.MerchantPaymentMethod != undefined &&
        this.Company.Configuration.MerchantPaymentMethod.length > 0
      ) {
        for (var i = 0; i < this.Company.Configuration.MerchantPaymentMethod.length; i++) {
          if (this.Company.Configuration.MerchantPaymentMethod[i].PaymentMethod.Code == "14") {
            this.Company.PaymentMethods.SMS = true;

            this.Company.Payment.SMS = {
              PaymentMethodCode: this.Company.Configuration.MerchantPaymentMethod[i].PaymentMethod.Code,
              Taxes: this.Company.Configuration.MerchantPaymentMethod[i].ListTax
            };

            this.DataPayment(this.Company.Payment.SMS);
          }
          if (this.Company.Configuration.MerchantPaymentMethod[i].PaymentMethod.Code == "16") {
            this.Company.PaymentMethods.AntiFraud = true;

            this.Company.Payment.AntiFraud = {
              PaymentMethodCode: this.Company.Configuration.MerchantPaymentMethod[i].PaymentMethod.Code,
              Taxes: this.Company.Configuration.MerchantPaymentMethod[i].ListTax
            };

            this.DataPayment(this.Company.Payment.AntiFraud);
          }
        }
      }

      if (this.Company.MerchantSplit != undefined && this.Company.MerchantSplit.length > 0) {
        for (var i = 0; i < this.Company.MerchantSplit.length; i++) {
          if (this.Company.MerchantSplit[i].PaymentMethod.Code == "1") {
            this.Company.PaymentMethods.BankSlip = true;

            this.Company.Payment.BankSlip = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.BankSlip);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "2") {
            this.Company.PaymentMethods.CreditCard = true;

            this.Company.Payment.CreditCard = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.CreditCard);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "3") {
            this.Company.PaymentMethods.Bitcoin = true;

            this.Company.Payment.Bitcoin = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.Bitcoin);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "4") {
            this.Company.PaymentMethods.DebitCard = true;

            this.Company.Payment.DebitCard = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.DebitCard);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "6") {
            this.Company.PaymentMethods.Pix = true;

            this.Company.Payment.Pix = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.Pix);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "14") {
            this.Company.PaymentMethods.SMS = true;

            this.Company.Payment.SMS = {
              PaymentMethodCode: this.Company.Configuration.MerchantPaymentMethod[i].Code
            };

            this.DataPayment(this.Company.Payment.SMS);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "15") {
            this.Company.PaymentMethods.AdvancePayment = true;

            this.Company.Payment.AdvancePayment = {
              IsSubaccountTaxPayer: this.Company.MerchantSplit[i].IsSubaccountTaxPayer,
              PaymentMethodCode: this.Company.MerchantSplit[i].PaymentMethod.Code,
              Taxes: this.Company.MerchantSplit[i].Taxes
            };

            this.DataPayment(this.Company.Payment.AdvancePayment);
          } else if (this.Company.MerchantSplit[i].PaymentMethod.Code == "16") {
            this.Company.PaymentMethods.AntiFraud = true;

            this.Company.Payment.AntiFraud = {
              PaymentMethodCode: this.Company.Configuration.MerchantPaymentMethod[i].Code
            };

            this.DataPayment(this.Company.Payment.AntiFraud);
          }
        }
      }
    },

    DataPayment(data) {
      const dataAux = {
        Taxes: []
      };
      if (data.Taxes != null) {
        if (data.IsSubaccountTaxPayer != null) {
          dataAux.transfer = data.IsSubaccountTaxPayer ? "Sim" : "Não";
        }

        for (var i = 0; i < data.Taxes.length; i++) {
          if (data.Taxes[i].Amount != null && data.Taxes[i].Amount != null) {
            data.Taxes.push({ taxType: data.Taxes[i].TaxType.Name, taxValue: data.Taxes[i].Amount });
          }

          if (data.Taxes[i].Tax != null && data.Taxes[i].Tax != null) {
            data.Taxes.push({ taxType: data.Taxes[i].TaxType.Name, taxValue: data.Taxes[i].Tax });
          }
        }
      }

      if (data.PaymentMethodCode == "1") {
        this.DataBankslip = dataAux;
      } else if (data.PaymentMethodCode == "2") {
        this.DataCreditCard = dataAux;
      } else if (data.PaymentMethodCode == "3") {
        this.DataBitcoin = dataAux;
      } else if (data.PaymentMethodCode == "4") {
        this.DataDebitCard = dataAux;
      } else if (data.PaymentMethodCode == "6") {
        this.DataPix = dataAux;
      } else if (data.PaymentMethodCode == "14") {
        this.DataSms = dataAux;
      } else if (data.PaymentMethodCode == "15") {
        this.DataAdvancePayment = dataAux;
      } else if (data.PaymentMethodCode == "16") {
        this.DataAntiFraud = dataAux;
      }
    }
  }
};
</script>

<style scoped>
.active-item {
  color: #fff !important;
  border-color: #00304d;
  background-color: #00304d;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.nav-tabs .active-item .nav-link {
  border-top-left-radius: unset;
  border-top-right-radius: unset;
}
.active-item a:-webkit-any-link {
  color: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/sub-components/Merchants/MerchantPaymentMethod.vue